import * as React from 'react';
import styled from '../../../utils/styled';
import {NotificationProps} from '../types';
import {BaseButton} from '../../Button';

interface RootProps extends Pick<NotificationProps, 'intent'> {}

const Root = styled('div')<RootProps>(({theme}) => ({
  display: 'flex',
  fontFamily: theme.fontFamily.base,
  lineHeight: 1.5,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  background: '#fff',
  borderRadius: 4,
  padding: '16px 24px',
  marginBottom: 16,
  position: 'relative',
  overflow: 'hidden'
}));

const Title = styled('div')({
  color: 'rgba(0,0,0,0.85)',
  fontSize: 16,
  lineHeight: '22px',
  marginBottom: 8
});

const Body = styled('div')({
  color: 'rgba(0,0,0,0.65)',
  fontSize: 14
});

export default class Notification extends React.Component<NotificationProps, {}> {
  static defaultProps = {
    showCloseButton: true,
    autoClose: true,
    duration: 4500
  };

  private _closeTimer: NodeJS.Timer | null;

  public componentDidMount() {
    this._startCloseTimer();
  }

  public componentWillUnmount() {
    this._clearCloseTimer();
  }

  public render() {
    const {title, body, showCloseButton} = this.props;

    const contents = (
      <div style={{flex: 1}}>
        <Title>{title}</Title>
        <Body>{body}</Body>
      </div>
    );

    const closeButton = showCloseButton ? (
      <div style={{position: 'absolute', top: 10, right: 10}}>
        <BaseButton onClick={this._close}>x</BaseButton>
      </div>
    ) : null;

    return (
      <Root onMouseEnter={this._clearCloseTimer} onMouseLeave={this._startCloseTimer}>
        {contents}
        {closeButton}
      </Root>
    );
  }

  private _close = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose(this.props);
    }
  };

  private _startCloseTimer = () => {
    if (this.props.autoClose) {
      this._closeTimer = setTimeout(() => {
        this._close();
        // tslint:disable-next-line:align
      }, this.props.duration!);
    }
  };

  private _clearCloseTimer = () => {
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Notifications/private/Notification.tsx